<template>
  <div class="video-wrapper">
    <video
      ref="videoPlayer"
      class="video-player"
      controls
      playsinline
      @play="playing = true"
    >
      <source :src="src" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div v-if="!playing" class="play-overlay" @click="startPlay">
      <div class="play-btn">
        <span class="play-icon">▶</span>
        <span>Click to play</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      playing: false,
    };
  },
  methods: {
    startPlay() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.play();
        this.playing = true;
      }
    },
  },
};
</script>

<style scoped>
.video-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 850px;
}

.video-player {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: block;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.25);
}

.play-btn {
  background: rgba(0, 0, 0, 0.65);
  color: white;
  padding: 16px 32px;
  border-radius: 50px;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
  backdrop-filter: blur(4px);
  transition: background 0.2s;
}

.play-overlay:hover .play-btn {
  background: rgba(255, 68, 56, 0.85);
}

.play-icon {
  font-size: 1.2rem;
}
</style>
